/**
 * Category volume store (DOM-free). Persisted through settings.ts; the
 * AudioManager and the Options "Music & Sounds" screen both go through here.
 */
import { CATEGORIES, type Category } from './types';
import { loadSoundVolumes, saveSoundVolumes } from '../settings';

const DEFAULTS: Record<Category, number> = {
  master: 1, music: 1, blocks: 1, hostile: 1, friendly: 1, players: 1, ambient: 1, weather: 1, ui: 1,
};

let values: Record<Category, number> | null = null;
const listeners: ((c: Category, v: number) => void)[] = [];

function ensure(): Record<Category, number> {
  if (!values) {
    values = { ...DEFAULTS };
    let saved: Record<string, number> = {};
    try { saved = loadSoundVolumes(); } catch { /* node / no storage */ }
    for (const c of CATEGORIES) if (typeof saved[c] === 'number') values[c] = saved[c];
  }
  return values;
}

export function getVolume(c: Category): number { return ensure()[c]; }

export function setVolume(c: Category, v: number): void {
  const vals = ensure();
  vals[c] = Math.min(1, Math.max(0, v));
  try { saveSoundVolumes(vals); } catch { /* ignore */ }
  for (const l of listeners) l(c, vals[c]);
}

export function onVolumeChange(fn: (c: Category, v: number) => void): void { listeners.push(fn); }

/** Label shown on the options sliders (vanilla names). */
export const CATEGORY_LABEL: Record<Category, string> = {
  master: 'Master Volume', music: 'Music', blocks: 'Blocks', hostile: 'Hostile Creatures',
  friendly: 'Friendly Creatures', players: 'Players', ambient: 'Ambient/Environment', weather: 'Weather', ui: 'Interface',
};
export { CATEGORIES } from './types';
